import { BuildVersion, EnvironmentModel } from './environment-model.interface';

export const environment: EnvironmentModel = {
  appId: 'com.apk.getmynudes',
  appName: 'GetMyNudes',
  gameName: 'Get My Nudes',
  production: true,
  serviceWorker: false,
  apiUrl: 'https://nutakuapi.getmynudes.com',
  buildVersion: BuildVersion.nutaku,
  variant: 'default',
  webSiteUrl: 'https://getmynudes.com',
  discordLink: 'https://discord.gg/3UNBKCX2ZH',
  rootPath: 'https://nutaku.getmynudes.com',
  mode: 'prod',
  showTncs: false,
  allowRegistrationForm: false,
  allowPaymentIframe: false,
  isPromoWidgetChat: false,
  showAdmobAds: false,
  showOnlineWebcamNotification: false,
  splashScreenImgSrc: 'assets/imgx/splash-bg.png',
  firebaseConfig: {
    apiKey: 'AIzaSyCvVXncecxc44-FzBSeBL3VHb4wyqzlTKE',
    authDomain: 'getmynudes.firebaseapp.com',
    projectId: 'getmynudes',
    storageBucket: 'getmynudes.firebasestorage.app',
    messagingSenderId: '23359976805',
    appId: '1:23359976805:web:b225c5ab99808d69d21d8c',
    measurementId: 'G-FJBD6F62FC',
  },
  nutakuConfig: {
    parentUrl: 'https://osapi.nutaku.com',
    buyGoldUrl: 'https://www.nutaku.net/members/cart/purchase/gold/',
  },
  policy: {
    name: 'GetMyNudes',
    url: 'https://getmynudes.com/',
    site: 'GetMyNudes.com',
    docsBaseUrl: 'https://info.getmynudes.com/legal/',
    email: 'info@getmynudes.com',
  },
  promoCodeIsAvailable: true,
  banners: [],
  appMetricaKey: '176d7169-8aa4-41da-bc1a-7fa4e9900f11',
};
